import {
    Grid,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    ListSubheader,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import ExternalScreen from '../../components/fragments/ExternalScreen';
import useSettings from '../../hooks/useSettings';
import { guestProfileSettings } from '../../store/local/contents';
import useAuth from '../../hooks/useAuth';

export default function GuestSettingsScreen() {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const { themeMode, onChangeMode } = useSettings();
    const { isPastor } = useAuth();

    const changeTheme = () => {
        const isLight = themeMode == 'light';
        const mode = { target: { value: isLight ? 'dark' : 'light' } };
        onChangeMode(mode);
    };

    return (
        <ExternalScreen
            title="myKanisa Settings"
            authPass
            disablePadding
            disableSpacing
        >
            <Grid item xs={12}>
                {guestProfileSettings.map(({ subheader, items }) => (
                    <List key={subheader}>
                        <ListSubheader className="text-uppercase">
                            {subheader}
                        </ListSubheader>
                        {items
                            ?.filter((item) => {
                                if (item.link == '/wallet' && !isPastor)
                                    return false;
                                else return true;
                            })
                            .map(({ title, icon, link, id }) => (
                                <ListItemButton
                                    onClick={() => {
                                        if (!id) {
                                            link && navigate(link);
                                            !link &&
                                                enqueueSnackbar('Coming soon', {
                                                    variant: 'info',
                                                });
                                        } else {
                                            id === 'theme' && changeTheme();
                                            id === 'faq' &&
                                                window.open(
                                                    'https://morfieltd.co.ke/F.A.Qs.html',
                                                    '_blank'
                                                );
                                            id === 'play' &&
                                                window.open(
                                                    'https://play.google.com/store/apps/details?id=com.morfie.kanisa',
                                                    '_blank'
                                                );
                                        }
                                    }}
                                    key={title}
                                >
                                    <ListItemIcon sx={{ pl: 2 }}>
                                        {icon}
                                    </ListItemIcon>
                                    <ListItemText primary={title} />
                                </ListItemButton>
                            ))}
                    </List>
                ))}
            </Grid>
        </ExternalScreen>
    );
}
